import { render } from "./JadwalRuang.vue?vue&type=template&id=023a42f6"
import script from "./JadwalRuang.vue?vue&type=script&lang=js"
export * from "./JadwalRuang.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__